<script setup>
import { useBreakpoints } from "@vueuse/core";

const programNames = ref([
  "Bachelor of Fine Arts - Creative Communication Design",
  "Bachelor of Architecture - Interior Architecture",
  "Bachelor of Fine Arts - Fashion Design",
  "Bachelor of Fine Arts - Interior Design",
  "Bachelor of Design - Multidisciplinary Design",
  "Bachelor of Arts - Creative Media Design",
  "Bachelor of Fine Arts - Design",
  "Bachelor of Arts - Digital Art",
  "Bachelor of Arts - Creative Media Design",
  "Bachelor of Arts - Digital Art",
  "Bachelor of Arts - Creative Media Design",
  "Bachelor of Architecture",
  "Bachelor of Arts - Creative Media Design",
  "Bachelor of Fine Arts - Design",
  "Bachelor of Arts Program in Creative Communication Design",
  "Bachelor of Arts - English for Applied Global Communication",
  "Bachelor of Arts - Business English",
  "Bachelor of Arts - Business Chinese",
  "Bachelor of Arts - Business Japanese",
  "Bachelor of Arts - Business French",
  "Bachelor of Arts in English-Chinese for Digital Communication",
  "Bachelor of Communication Arts - Innovative Media Production",
  "Bachelor of Arts in Music Entrepreneurship",
  "Bachelor of Communication Arts - Advertising and Digital Marketing Communication",
  "Bachelor of Business Administration - Hospitality & Tourism Management",
  "Bachelor of Business Administration - Airline Business Management",
  "Master of Fine Arts - Design",
  "Master of Architecture - Architecture for the Community and Environment",
  "Master of Science - Cyber Security Management and Technology",
  "Master of Arts - Diplomacy and International Studies",
  "Master of Education - Bilingual Education",
  "Master of Arts - English Language Teaching",
  "Master of Arts - Philosophy and Religion",
  "Master of Science - International Digital Business",
  "Master of Communication Arts - Film and Series Writing and Directing",
  "Master of Business Administration - Hospitality and Tourism Management",
  "Master of Business Administration in Digital Marketing",
  "Master of Education - Curriculum and Instruction",
  "Master of Science - Remote Sensing and Geographic Information System",
  "Master of Engineering - Energy Technology and Management",
  "Master of Science - Environmental Science",
  "Master of Science - International Digital Business",
  "Master of Science - Data Science and Artificial Intelligence",
  "Master of Business Administration - Hospitality and Tourism Management",
]);

const breakpoints = useBreakpoints(BREAKPOINTS);
const activeBreakpoints = breakpoints.active();

const programsCount = computed(() => {
  switch (activeBreakpoints.value) {
    case "mobile":
      return 20;
    case "desktop":
      return 32;
    default:
      return 32;
  }
});

const queryPayload = computed(() => {
  return programNames.value
    .map((name, index) => "name_list[" + index + "]=" + name + "&")
    .join("");
});

const { data: programLists } = usePublicFetch(
  () =>
    `programs/name/list?featured=true&page=1&pageSize=${programsCount.value}`,
  {
    method: "GET",
    key: "footer-program-lists",
  },
);
</script>

<template>
  <p class="text-lg font-bold px-2 lg:px-0">Popular Programs</p>
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-2 gap-x-10 mt-4 px-2 lg:px-0"
  >
    <div
      v-for="program in programLists?.data"
      :key="program.id"
      class="space-y-4"
    >
      <NuxtLink :to="`/programs/${program.slug}`" class="text-sm hover:underline">
        {{ program.name }}
      </NuxtLink>
    </div>
  </div>
</template>
